import * as React from "react";
import { FormComponentProps } from 'antd/lib/form';
import { IExpenseTradeItemCreate } from 'src/services/interfaces/Expense/IExpenseTradeItemCreate';
import "./ExpenseItemCard.scss";
import { Row, Col, Button, Tooltip } from 'antd';
import { ExpenseCategoryEnum } from 'src/services/Enum/ExpenseCategoryEnum';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IExpenseItemCreate } from 'src/services/interfaces/Expense/IExpenseItemCreate';
import { ExpenseViewTradeInfo } from './ExpenseViewTradeInfo/ExpenseViewTradeInfo';
import { ExpenseAddCategoryAndValue } from './ExpenseAddCategoryAndValue/ExpenseAddCategoryAndValue';
import { ExpenseViewCategoryAndValue } from './ExpenseViewCategoryAndValue/ExpenseViewCategoryAndValue';

interface IExpenseItemCardProps extends FormComponentProps {
    expenseItem: IExpenseTradeItemCreate;
    onItemUpdate: (tradeId: number, expenseItem: IExpenseItemCreate) => void;
    onRemove: (tradeId: number) => void;
    onItemDelete: (tradeId: number, category: ExpenseCategoryEnum) => void;
}

export const ExpenseItemCard: React.FC<IExpenseItemCardProps> = ({
    expenseItem,
    onItemUpdate,
    form,
    onRemove,
    onItemDelete
}) => {
    const cardIsEmpty = expenseItem.listCategories.length === 0;
    function onRemoveItem(categoryDeleted: ExpenseCategoryEnum) {
        onItemDelete(expenseItem.tradeId, categoryDeleted);
    }

    return (
        <div className="item-card">
            <div className="expense-item-header" style={{ border: cardIsEmpty ? "2px solid #f5222d" : "2px solid #418fde" }}>
                <Col xs={24} sm={24} md={24} lg={24}>
                    <Row gutter={26} type="flex" align="top">
                        <Col xs={24} sm={24} md={20} lg={20}>
                            <ExpenseViewTradeInfo expenseItem={expenseItem} />
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4}>
                            <Row gutter={26} type="flex" justify="end" align="top">
                                <Tooltip title={`Remover trade ${expenseItem.tradeId}`}>
                                    <Button type="danger" className="icon-only remove btn" onClick={() => onRemove(expenseItem.tradeId)}>
                                        <FontAwesomeIcon icon={faTrash} color="red" />
                                    </Button>
                                </Tooltip>
                            </Row>
                        </Col>
                    </Row>

                    <Row gutter={26}>
                        <ExpenseAddCategoryAndValue
                            expenseItem={expenseItem}
                            form={form}
                            onItemUpdate={onItemUpdate}
                            defaultCategory={ExpenseCategoryEnum.COMISSAO}
                        />
                    </Row>

                    {expenseItem.listCategories.map((obj) => (
                        <ExpenseViewCategoryAndValue
                            listCategory={obj}
                            onRemoveItem={onRemoveItem}
                        />
                    )
                    )}
                </Col>
            </div>
            {cardIsEmpty && <p className="item-card-error">Adicione o valor e categoria ao trade</p>}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/common/ExpenseItemCard/ExpenseItemCard.tsx